"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGigya = exports.GigyaProvider = void 0;
const react_1 = __importStar(require("react"));
const GigyaContext = (0, react_1.createContext)(undefined);
const GigyaProvider = ({ children, apiKey, domain }) => {
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (typeof window !== 'undefined' && !(window === null || window === void 0 ? void 0 : window.gigya)) {
            const script = document.createElement('script');
            const scriptSrc = `${domain}/js/gigya.js?apiKey=${apiKey}`;
            script.src = scriptSrc;
            script.async = true;
            // Define the onGigyaReady callback
            window.onGigyaReady = () => {
                console.log('Gigya is ready');
                setIsLoaded(true);
            };
            script.onload = () => {
                if (window.gigya) {
                    // In case onGigyaReady isn't triggered
                    setIsLoaded(true);
                }
            };
            const head = document.head || document.getElementsByTagName('head')[0];
            head.appendChild(script);
        }
        else {
            // If gigya is already loaded
            setIsLoaded(true);
        }
        // Cleanup on unmount
        return () => {
            const script = document.querySelector(`script[src^="${domain}/js/gigya.js"]`);
            if (script) {
                document.head.removeChild(script);
            }
            window.onGigyaReady = undefined; // Clean up the callback
        };
    }, [apiKey, domain]);
    const gigya = typeof window !== "undefined" ? window.gigya || null : null;
    return (react_1.default.createElement(GigyaContext.Provider, { value: { gigya, isLoaded } }, children));
};
exports.GigyaProvider = GigyaProvider;
// Custom hook to access Gigya context
const useGigya = () => {
    const context = (0, react_1.useContext)(GigyaContext);
    if (!context) {
        throw new Error('useGigya must be used within a GigyaProvider');
    }
    return context;
};
exports.useGigya = useGigya;
